import { render, staticRenderFns } from "./NlcTable.vue?vue&type=template&id=bf047ae0"
import script from "./NlcTable.vue?vue&type=script&lang=ts"
export * from "./NlcTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports